import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/system';
import { OPACITY_13 } from 'constants/opacity';
import { calculateRgbaWithAlpha } from 'helpers/colorFormatter';
import CartItem from 'components/Cart/CartItem';
import CartItemActions from 'bento-ordering/cart/components/CartItemActions';
import CartItemSkeleton from 'bento-ordering/cart/components/CartItemSkeleton';
import { updateCartItem } from 'bento-ordering/cart/actions';
import { selectIsFetchingAddToCart } from 'bento-ordering/cart/selectors/index';
import getTransformedRequiredFieldsForCartItem from 'helpers/forms/getTransformedRequiredFieldsForCartItem';
import { useHasInvestorDayFeatureFlag } from 'bento-ordering/utils/featureFlags/hasInvestorDayFeatureFlag';

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  borderBottom: `1px solid ${calculateRgbaWithAlpha(
    theme.palette.sectionNav.link.main,
    OPACITY_13
  )}`
}));
function CartItemsList({
  items = [],
  getEditCartItemPath,
  removeItemFromCart,
  handleClose,
  currentCartPath,
  showCartQuantity = false
}) {
  const dispatch = useDispatch();
  const updateCartItemQuantity = (item, quantity) => {
    const transformedRequiredFields = getTransformedRequiredFieldsForCartItem(
      item.required_fields
    );

    return dispatch(
      updateCartItem(parseInt(item.id), {
        product_id: item.product,
        required_fields: transformedRequiredFields,
        quantity: quantity
      })
    );
  };

  const hasInvestorDayFeature = useHasInvestorDayFeatureFlag();
  const isCartFetching = useSelector(selectIsFetchingAddToCart);

  return (
    <Box component={List} disablePadding data-testid="cart-items-list">
      {items.map(item => {
        const editCartItemPath = getEditCartItemPath(item.id);
        const handleRemoveCartItem = () => removeItemFromCart(item.id);

        return (
          <StyledListItem key={item.id} disableGutters divider>
            <CartItem
              item={item}
              itemActions={
                <CartItemActions
                  currentCartPath={currentCartPath}
                  editCartItemPath={editCartItemPath}
                  onEditCartItem={handleClose}
                  onRemoveCartItem={handleRemoveCartItem}
                />
              }
              updateQuantity={updateCartItemQuantity}
              showCartQuantity={showCartQuantity}
              hasInvestorDayFeature={hasInvestorDayFeature}
            />
          </StyledListItem>
        );
      })}
      {isCartFetching && (
        <StyledListItem disableGutters divider>
          <CartItemSkeleton />
        </StyledListItem>
      )}
    </Box>
  );
}

CartItemsList.propTypes = {
  items: PropTypes.array,
  getEditCartItemPath: PropTypes.func,
  removeItemFromCart: PropTypes.func,
  handleClose: PropTypes.func,
  currentCartPath: PropTypes.string,
  showCartQuantity: PropTypes.bool
};

export default CartItemsList;
